import React from 'react';

const SMSComponent = () => {
  const smsPackages = [
    {
      sms: '25 SMS',
      duration: '30 Days',
      price: 'R7.50'
    },
    {
      sms: '50 SMS',
      duration: '30 Days',
      price: 'R15'
    },
    {
      sms: '100 SMS',
      duration: '30 Days',
      price: 'R30'
    },
    {
      sms: '200 SMS',
      duration: '30 Days',
      price: 'R45'
    },
    {
      sms: '300 SMS',
      duration: '30 Days',
      price: 'R65'
    },
    {
      sms: '500 SMS',
      duration: '30 Days',
      price: 'R105'
    }
  ];

  const styles = {
    container: {
      background: '#3A8181',
      borderRadius: '16px',
      padding: '32px',
      margin: '0 auto',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
      fontFamily: 'Poppins, sans-serif', 
      maxWidth: '600px',
    },
    header: {
      color: 'white',
      fontSize: '28px',
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: '32px',
      letterSpacing: '1px'
    },
    packageRow: {
      display: 'grid',
      gridTemplateColumns: '120px 1fr 80px',
      alignItems: 'center',
      paddingBottom: '16px',
      marginBottom: '16px',
      borderBottom: '1px solid rgba(255, 255, 255, 0.3)',
      gap: '20px'
    },
    lastPackageRow: {
      display: 'grid',
      gridTemplateColumns: '120px 1fr 80px',
      alignItems: 'center',
      paddingBottom: '16px',
      gap: '20px'
    },
    smsText: {
      color: 'white',
      fontSize: '18px',
      fontWeight: '400',
      textAlign: 'left',
      justifySelf: 'start'
    },
    durationText: {
      color: 'white',
      fontSize: '18px',
      fontWeight: '400',
      textAlign: 'center',
      justifySelf: 'center'
    },
    priceText: {
      color: 'white',
      fontSize: '18px',
      fontWeight: '400',
      textAlign: 'right',
      justifySelf: 'end'
    }
  };

  const PackageItem = ({ pkg, isLast = false }) => (
    <div style={isLast ? styles.lastPackageRow : styles.packageRow}>
      <span style={styles.smsText}>{pkg.sms}</span>
      <span style={styles.durationText}>{pkg.duration}</span>
      <span style={styles.priceText}>{pkg.price}</span>
    </div>
  );

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>
        STANDARD RATES
      </h2>
   <p style={{paddingBottom: "20px", textAlign: "center"}}>      <strong>k'nect bundles are available at all tills in-store, via USSD *135# or on Money Market Account.</strong>
      </p>
      <div>
        {smsPackages.map((pkg, index) => (
          <PackageItem
            key={index}
            pkg={pkg}
            isLast={index === smsPackages.length - 1}
          />
        ))}
      </div>
    </div>
  );
};

export default SMSComponent;